//*Libraries imports
import { useState, useEffect, useCallback, Suspense } from "react";

//*Components imports
import SignatureFormModal from "./components/SignatureFormModal";
import SignatureViewModal from "./components/SignatureViewModal";
import { BsPencil, BsEye, BsPlus } from "react-icons/bs";
import { CircularProgress } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";

//*Manager imports
import InscricoesCriteriosAssinaturasManager from "./InscricoesCriteriosAssinaturasManager";
import { useSelector } from "react-redux";

function InscricoesCriteriosAssinaturas() {
  const [loading, setLoading] = useState(true);
  const [signatures, setSignatures] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const user = useSelector(store=>store.AppReducer.user);

  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null);
  const [signatureData, setSignatureData] = useState(null);
  const [loadingData, setLoadingData] = useState(false);

  const fetchList = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const res = await InscricoesCriteriosAssinaturasManager.Get(page);
      if (res?.result) {
        setSignatures(res.data.signatures);
        setPagination(res.data.pagination);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const openModal = async (key, type) => {
    setSelectedKey(key);
    setSignatureData(null);
    if (type === "view") setShowView(true);
    else setShowForm(true);

    setLoadingData(true);
    try {
      const res = await InscricoesCriteriosAssinaturasManager.ShowByKey(key);
      if (res?.data) setSignatureData(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingData(false);
    }
  };

  const handleSave = async (formData) => {
    formData.append("criterio_selecao_chave", selectedKey);
    try {
      const res = signatureData?.id
        ? await InscricoesCriteriosAssinaturasManager.Update(
            signatureData.id,
            formData,
          )
        : await InscricoesCriteriosAssinaturasManager.Store(formData);

      if (res?.result) {
        await fetchList(pagination.current_page);
      }
      return res;
    } catch (e) {
      console.error(e);
      return { result: false, message: "Erro ao salvar." };
    }
  };

  const formatKey = (key) => {
    const map = {
      sisu: "SISU",
      prouni_fies: "ProUni / FIES",
      faculdade_privada_enem: "Faculdade Privada (ENEM)",
      estagio_jovem_aprendiz: "Estágio / Jovem Aprendiz",
      emprego_privado: "Emprego Privado",
      concurso: "Concurso",
    };
    return (
      map[key] ||
      key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
    );
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="pt-0 header-title">
              Assinaturas de Critérios de Seleção
            </h4>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Critério</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="3" className="text-center py-5">
                        <CircularProgress />
                      </td>
                    </tr>
                  ) : signatures.length === 0 ? (
                    <tr>
                      <td colSpan="3" className="text-center py-4">
                        Nenhum registro.
                      </td>
                    </tr>
                  ) : (
                    signatures.map((item, idx) => (
                      <tr key={idx}>
                        <td>{formatKey(item.selection_criterion_key)}</td>
                        {((item?.has_signature?.caminho_arquivo_assinatura_1 && user.email=='gislaina.sleal@adm.educacao.pe.gov.br')
                          || (item?.has_signature?.caminho_arquivo_assinatura_2 && user.email=='izabel.cprocha@adm.educacao.pe.gov.br')
                          || (item?.has_signature?.caminho_arquivo_assinatura_3 && user.email=='ana.elizabete1962@adm.educacao.pe.gov.br')
                          || (item?.has_signature?.caminho_arquivo_assinatura_1
                            && item?.has_signature?.caminho_arquivo_assinatura_2
                            && item?.has_signature?.caminho_arquivo_assinatura_3
                            && user.email!='ana.elizabete1962@adm.educacao.pe.gov.br'
                            && user.email!='izabel.cprocha@adm.educacao.pe.gov.br'
                            && user.email!='gislaina.sleal@adm.educacao.pe.gov.br'
                          )

                      ) ? <td
                          className="text-center"
                          style={{
                            color:  "green" ,
                          }}
                        >
                          { "Assinado"}
                        </td>:<td
                          className="text-center"
                          style={{
                            color: "orange",
                          }}
                        >
                          {"Pendente"}
                        </td>}
                        <td className="text-center d-flex align-items-center justify-content-center gap-2">
                          {item.has_signature && (
                            <button
                              className="btn btn-sm btn-info"
                              onClick={() =>
                                openModal(item.selection_criterion_key, "view")
                              }
                              title="Visualizar"
                            >
                              <BsEye size={16} />
                            </button>
                          )}
                          <button
                            className={`btn btn-sm ${item.has_signature ? "btn-primary" : "btn-success"}`}
                            onClick={() =>
                              openModal(item.selection_criterion_key, "form")
                            }
                            title={item.has_signature ? "Editar" : "Criar"}
                          >
                            {item.has_signature ? (
                              <BsPencil size={16} />
                            ) : (
                              <BsPlus size={16} />
                            )}
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            {pagination.last_page > 1 && (
              <Pagination
                className="d-flex justify-content-end pt-3"
                count={pagination.last_page}
                page={pagination.current_page}
                onChange={(e, v) => fetchList(v)}
              />
            )}
          </div>
        </div>
      </div>

      <Suspense fallback={null}>
        <SignatureFormModal
          show={showForm}
          handleClose={() => setShowForm(false)}
          handleSave={handleSave}
          existingSignature={signatureData}
          loading={loadingData}
        />
        <SignatureViewModal
          show={showView}
          handleClose={() => setShowView(false)}
          data={signatureData}
          loading={loadingData}
          selectionKey={selectedKey}
        />
      </Suspense>
    </div>
  );
}

export default InscricoesCriteriosAssinaturas;
